import { CalibrationComponentType } from "../../../../navigation/CalibrationNavigator";
import {
  getCalibrationImage,
  getCalibrationStrings,
  Steps,
} from "../../../../utils/helpers/calibration-screen";
import SimpleButton from "../../../../components/disposables/buttons/SimpleButton";
import styles from "../../../../screens/Calibration/styles.module.css";
import { useState } from "react";
import { NewRobotIdE, useConnectedRafts } from "../../../../store/SelectedRaftContext";
import { useTranslation } from "react-i18next";

interface ArmCalibrationScreenProps extends CalibrationComponentType { }

export default function ArmCalibration({
  currentScreenSetter,
}: ArmCalibrationScreenProps) {
  const { t } = useTranslation();
  const { connectedRafts } = useConnectedRafts();
  const selectedRaft = connectedRafts.find(connectedRaft => connectedRaft.isSelected && connectedRaft.id !== NewRobotIdE.NEW);
  const [isBusy, setBusy] = useState<boolean>(false);

  const onSaveCalibration = async () => {
    if (!selectedRaft) {
      return;
    }
    try {
      setBusy(true);
      await window.applicationManager.calibrateMarty(selectedRaft.id, "set", "arms");
      setBusy(false);
      currentScreenSetter("done-calibration");
    } catch {
      console.warn(`Failed to execute calibration step`);
    }
  };
  return (
    <div className={styles["calibration-screen-container"]}>
      <div className={styles["calibration-screen-marty-image-container"]}>
        <img src={getCalibrationImage(Steps.STEP_ARMS_01)} alt="marty-image" />
      </div>
      <div className={styles["calibration-screen-middle-text-container"]}>
        <p className={styles["calibration-screen-middle-text-title"]}>
          {getCalibrationStrings(Steps.STEP_ARMS_01).title}
        </p>
        <p className={styles["calibration-screen-middle-text-subtitle"]}>
          {getCalibrationStrings(Steps.STEP_ARMS_01).hint}
        </p>
        {!isBusy ? (
          <></>
        ) : (
          <p className={styles["calibration-screen-middle-text-subtitle"]}>
            {t("calibration_screen.communicating")}
          </p>
        )}
      </div>
      <div className={styles["calibration-screen-bottom-buttons-container"]}>
        <SimpleButton
          title={t("calibration_screen.save_arms")}
          onClick={onSaveCalibration}
        />
      </div>
    </div>
  );
}
